import { isCreditLensFeatureEnabled } from "src/configState/selector";
import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../../../api";
import { getSpreadId } from "../../model/spread/selector";
import { EditTagText, TagArea, TagConfig } from "./types";

const create = actionCreatorFactory("Tags");
const createAsync = asyncFactory(create);

export const saveTagArea = createAsync<TagArea, TagArea>(
  "SAVE_TAG_AREA",
  async (area, dispatch, getState) => {
    const isCreditLens = isCreditLensFeatureEnabled(getState());
    const spreadId = getSpreadId(getState());
    return await api.tag.saveArea(area, isCreditLens, spreadId);
  }
);

const saveTagAreaAction = thunkToAction(saveTagArea.action);
export type SaveTagAreaActionType = typeof saveTagAreaAction;

export const setActiveTagArea = create<string | null>("SET_ACTIVE_TAG_AREA");
export const appendTagArea = create<TagArea>("APPEND_TAG_AREA");
export const enableTagMode = create("ENABLE_TAG_MODE");
export const disableTagMode = create("DISABLE_TAG_MODE");
export const setTagConfig = create<TagConfig>("SET_TAG_CONFIG");
export const editTagAreaText = create<EditTagText>("EDIT_TAG_AREA_TEXT");



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/Tag/actions.ts